// extracted by mini-css-extract-plugin
export default {"spinner":"QtSIt","error":"gt4QD","empty":"VN2cg","list":"XcDaL","header":"wcndX"};